import { useState } from "react";

import { ProcessStatusCode } from "@/types/code.types";
import useModal from "@hooks/useModal";
import { PressListData } from "@PressListContainer/pressList.types";

import PressListCheckStatusGuide from "./components/PressListTableShellForPressTitle/components/PressListCheckStatusGuide/PressListCheckStatusGuide";
import PressListTableShellForPressTitle from "./components/PressListTableShellForPressTitle/PressListTableShellForPressTitle";

type Props = {
  pressListItem: PressListData;
  updatePressList: () => void;
  pressListData: PressListData[];
};

const PressListPressTitleContainer = ({
  updatePressList,
  pressListItem,
  pressListData,
}: Props) => {
  const [targetPressId, setTargetPressId] = useState(0);
  const [currentStatus, setCurrentStatus] = useState<ProcessStatusCode | "">(
    "",
  );

  const {
    isModal: isCheckStatusModal,
    closeModal: closeCheckStatusModal,
    openModal: openCheckStatusModal,
  } = useModal();

  const handleTargetPressId = (id: number) => {
    setTargetPressId(id);
  };

  const handleCurrentStatus = (status: ProcessStatusCode | "") => {
    setCurrentStatus(status);
  };

  return (
    <>
      <PressListTableShellForPressTitle
        key={pressListItem.pressId}
        pressData={pressListItem}
        openCheckStatusModal={openCheckStatusModal}
        handleTargetPressId={() => handleTargetPressId(pressListItem.pressId)}
        handleCurrentStatus={handleCurrentStatus}
      />

      {isCheckStatusModal && (
        <PressListCheckStatusGuide
          closeModal={closeCheckStatusModal}
          draftArticleId={targetPressId}
          updatePressList={updatePressList}
          pressListData={pressListData || []}
          currentStatus={currentStatus}
        />
      )}
    </>
  );
};

export default PressListPressTitleContainer;
